<template>
  <div class="retry" :class="{'is-absolute': isFooterShow}">
    <button @click="$emit('clickedButton')" class="retry-button">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.77 13" class="retry-arrow">
        <path class="cls-1" d="M5.88,0A5.89,5.89,0,0,0,0,5.88a.57.57,0,1,0,1.13,0,4.75,4.75,0,1,1,4.75,4.75H3.29l.27-.26a.58.58,0,0,0,0-.81.57.57,0,0,0-.8,0L1.53,10.8a.57.57,0,0,0,0,.8l1.23,1.23a.58.58,0,0,0,.4.17.56.56,0,0,0,.4-.17.57.57,0,0,0,0-.8l-.27-.26H5.88A5.89,5.89,0,1,0,5.88,0Z"/>
      </svg>
      <span class="retry-text">やり直す</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PartRetry',
  props: {
    isAbsolute: {
      type: Boolean,
      default: false
    },
    isFooterShow: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.retry {
  padding: 20/375 * 100% 20/375 * 100% 0 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  @include media() {
    position: fixed;
    left: 0;
    right: auto;
    top: auto;
    bottom: 0;
    padding: 0 0 40px 40px;
  }
  &.is-absolute {
    @include media() {
      position: absolute;
    }
  }
  &-button {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 76/375 * 100vw;
    padding: 4.5/375 * 100vw 0;
    border-radius: 12/375 * 100vw;
    background: #DF0068;
    @include media() {
      flex-direction: column;
      width: 100px;
      padding: 25px 0 26px;
      border-radius: 50%;
    }
  }
  &-arrow {
    width: 9/375 * 100vw;
    height: 10/375 * 100vw;
    fill: #fff;
    @include media() {
      width: 18px;
      height: 20px;
      transition: .45s ease;
    }
  }
  &-text {
    margin-left: 5/375 * 100vw;
    color: #fff;
    font-size: 10/375 * 100vw;
    line-height: (15/10);
    @include media() {
      margin-left: 0;
      margin-top: 8px;
      font-size: 14px;
      letter-spacing: .05em;
      transition: .45s ease;
      .retry-button:hover & {
        letter-spacing: .3em;
      }
    }
  }
}
</style>
